import { Controller } from "@hotwired/stimulus"

// Progressively reveals more rows of a capped list. The first batch is visible
// server-side; the rest render with the `hidden` attribute. Each click on the
// "more" button un-hides the next `step` rows, and the button removes itself
// once every row is shown.
export default class extends Controller {
  static targets = ["row", "more"]
  static values = { step: { type: Number, default: 20 } }

  more() {
    const hidden = this.rowTargets.filter((row) => row.hidden)
    hidden.slice(0, this.stepValue).forEach((row) => (row.hidden = false))
    if (hidden.length <= this.stepValue && this.hasMoreTarget) this.moreTarget.hidden = true
  }
}
